import { StyledButtonWrapper } from "./StyledButtonWrapper";
import { DefaultButton } from "./DefaultButton";

export const Button = StyledButtonWrapper(DefaultButton);
